<template>
  <Popover :title="title" ref="popover" @show="onPopoverShow" @hide="onPopoverHide">
    <span>设置起量预算&ensp;</span>
    <el-input-number
      v-model="innerValue"
      controls-position="right"
      :precision="2"
      :step="1"
      :min="0"
      :max="99999999"
      style="width: 130px"
    />

    <div style="display: inline-block">
      <el-button type="text" @click="confirm">&ensp;保存</el-button>
    </div>

    <div slot="ref">
      <slot></slot>
    </div>
  </Popover>
</template>

<script>
import Popover from '@/components/popover/index.vue'
import { truncatedNumber } from '@/common/js/utils.js'

export default {
  components: { Popover },
  props: {
    value: [Number, String],
    title: String,
    precision: {
      type: Number,
      default: 2
    },
    max: {
      type: Number,
      default: 99999999
    }
  },
  data() {
    return {
      innerValue: ''
    }
  },
  methods: {
    confirm() {
      this.$emit('input', truncatedNumber(parseFloat(this.innerValue), this.precision))
      this.$refs.popover.close()
    },
    onPopoverShow() {
      if (this.value > 0) {
        this.innerValue = this.value
      }
    },
    onPopoverHide() {
      this.innerValue = ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
